export default __webpack_public_path__ + "static/media/icon-close.b26abe2d.svg";